import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const environmentalPerformanceRoutes: RouteRecordRaw[] = [
  {
    path: "/environmental-performance-report",
    name: "environmentalPerformanceReport",
    component: () =>
      import("@/views/restricted/environmental-performance/EnvironmentalPerformanceReportView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "environmentalPerformanceReport",
      requiresAuth: true,
    },
  },
];

export default environmentalPerformanceRoutes;
